import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17.875 4.313h-1.313a.375.375 0 01-.375-.375V3.75a.75.75 0 00-.75-.75h-2.25a.75.75 0 00-.75.75v7.125a.375.375 0 00.233.345.353.353 0 00.405-.083l1.103-1.102a.203.203 0 01.27 0l1.102 1.102a.353.353 0 00.262.113.375.375 0 00.376-.375V6.187a.375.375 0 01.375-.375h.937a.375.375 0 01.375.375v12.938a.375.375 0 01-.375.375H8.125a.375.375 0 01-.375-.375V6.187a.375.375 0 01.375-.375h3a.188.188 0 00.188-.187V4.5a.188.188 0 00-.188-.188H5.5a1.5 1.5 0 00-1.5 1.5V19.5A1.5 1.5 0 005.5 21h12.375a1.5 1.5 0 001.5-1.5V5.812a1.5 1.5 0 00-1.5-1.5z",
      fill: "#333"
    }
  )
);
export {
  t as default
};
